import { jsx as o, jsxs as j } from "react/jsx-runtime";
import { forwardRef as F, cloneElement as L } from "react";
import { useMultiStyleConfig as O, Flex as P, Box as v, Divider as T } from "@chakra-ui/react";
import { FormControl as q } from "../FormControl/FormControl.mjs";
import { Input as z } from "../Input/Input.mjs";
import { combineClasses as B } from "../../../utils/combineClasses.mjs";
import "react-nanny";
const e = (i) => i === "left", E = F(
  (i, x) => {
    const {
      children: C,
      name: n,
      className: I,
      controlStyleProps: N,
      controlClassName: g,
      "data-testid": r,
      error: a,
      formHelperText: y,
      formInput: D,
      hideOptionalLabel: b = !1,
      id: p = n,
      isDisabled: s,
      isReadOnly: l,
      isRequired: d,
      label: w,
      selectPosition: t = "left",
      size: m = "md",
      variant: c,
      ...R
    } = i, u = O("DualInput"), S = D || z, f = L(C, {
      isInvalid: a,
      isDisabled: s,
      isReadOnly: l,
      isRequired: d,
      size: m,
      variant: l ? "filled" : c,
      className: e(t) ? "dual-input-left" : "dual-input-right",
      controlClassName: e(t) ? "dual-input-left-control" : "dual-input-right-control"
    }), h = /* @__PURE__ */ o(
      S,
      {
        ref: x,
        name: n,
        id: p,
        "data-testid": r,
        className: B(
          e(t) ? "dual-input-right" : "dual-input-left",
          I
        ),
        controlClassName: e(t) ? "dual-input-right-control" : "dual-input-left-control",
        isInvalid: a,
        isDisabled: s,
        isReadOnly: l,
        isRequired: d,
        size: m,
        variant: l ? "filled" : c,
        ...R
      }
    );
    return /* @__PURE__ */ o(
      q,
      {
        name: n,
        hideOptionalLabel: b,
        id: p,
        error: a,
        label: w,
        isDisabled: s,
        isReadOnly: l,
        isRequired: d,
        formHelperText: y,
        "data-testid": r && `${r}-control`,
        className: g,
        ...N,
        children: /* @__PURE__ */ j(P, { sx: u.container, direction: "row", wrap: "nowrap", children: [
          /* @__PURE__ */ o(v, { ...!e(t) && { flex: 1 }, children: e(t) ? f : h }),
          (l || c === "filled") && /* @__PURE__ */ o(T, { orientation: "vertical", sx: u.divider }),
          /* @__PURE__ */ o(v, { ...e(t) && { flex: 1 }, children: e(t) ? h : f })
        ] })
      }
    );
  }
);
E.displayName = "DualInputv2";
export {
  E as DualInputv2
};
